import type {AnyQueryRoute} from '@github-ui/react-core/future/query-route'
import type {ComponentProps} from 'react'

import {usePendingSavedViewSearch} from '../../hooks/use-saved-view-navigation'
import {useSavedViewPrefetch} from '../../hooks/use-saved-view-prefetch'
import {SavedViewUrlConfiguration} from './SavedViewUrlConfiguration'

type ConnectedSavedViewUrlConfigurationProps<Route extends AnyQueryRoute> = Omit<
  ComponentProps<typeof SavedViewUrlConfiguration>,
  'pendingSearch' | 'onPrefetch'
> & {
  /** The route that serves the view. Likely picks preload it. */
  route: Route
  /** The route params of the view on screen. */
  params: Parameters<Route['preload']>[0]
}

/**
 * `SavedViewUrlConfiguration` connected to the router. A pick shows in the menu while it loads,
 * and the next pick builds on it. Picks that look likely load ahead through `route`.
 *
 * Needs a data router.
 */
export function ConnectedSavedViewUrlConfiguration<Route extends AnyQueryRoute>({
  route,
  params,
  ...props
}: ConnectedSavedViewUrlConfigurationProps<Route>) {
  const pendingSearch = usePendingSavedViewSearch()
  const prefetch = useSavedViewPrefetch(route, params)

  return <SavedViewUrlConfiguration {...props} pendingSearch={pendingSearch} onPrefetch={prefetch} />
}
